import { ReactComponent as Forward15OutlinedIcon } from 'assets/icons/forward-15-outlined.svg';

export default Forward15OutlinedIcon;
